import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  AlertController,
  LoadingController,
  Events,
  ToastController
} from "ionic-angular";
import { Stripe } from '@ionic-native/stripe';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from "../../services/AuthService";
import { FirestoreService } from "../../services/FirestoreService";
import { Http, Headers } from '@angular/http';
import { InAppBrowser } from "@ionic-native/in-app-browser";

declare var StripeCheckout;

@IonicPage()
@Component({
  selector: "page-sign-up",
  templateUrl: "sign-up.html"
})
export class SignUpPage {
  signUpSegment: string = "cancel";
  registerData: any;
  public form: FormGroup;
  public form2: FormGroup;
  cardNumber: string;
  cardExpiry: any;
  cardExpiryM: any;
  cardExpiryY: any;
  cardCvv: string;
  location: string = "GN";
  mainLoader: any;
  maxLength: Number;
  currency: string;
  subscriptionLabel: string;
  handler: any;
  subscribeMe: boolean = false;
  termsChecked: boolean = false;


  constructor(
    private navCtrl: NavController,
    private fb: FormBuilder,
    private http: Http,
    private events: Events,
    private firestoreService: FirestoreService,
    private stripe: Stripe,
    private toastCtrl: ToastController,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private iab: InAppBrowser,
    private loadingCtrl: LoadingController
  ) {
    this.registerData = { email: "", password: "", password2: "" };
    this.form = this.fb.group({
      username: ['', Validators.required],
      eula: [null, Validators.required],
      currencyWeb: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.form2 = this.fb.group({
      cardNumber: ['', Validators.required],
      cardExpiry: ['', Validators.required],
      cardCvv: ['', Validators.required],
      currency: ['', Validators.required]
    });

    this.currency = 'gnf';
    this.subscriptionLabel = 'GNF20,000';

  }

  regNoSubs() {

    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Getting ready... Please wait"
    });

    loading.present();

    this.authService
      .registerUser(
        this.registerData.email,
        this.registerData.password,
        this.registerData.password
      )
      .then(x => {
        console.log('-----');
        console.log(x);
        loading.dismiss();


        let alert = this.alertCtrl.create({
          title: "Thank You",
          subTitle: "Registration was successful. Please verify your email address to access your account!",
          buttons: ["Dismiss"]
        });

        alert.present();
        alert.onDidDismiss( () => {
          this.navCtrl.pop();
        });

        this.navCtrl.setRoot("SignInPage");
      })
      .catch(error => {
        loading.dismiss();

        let alert = this.alertCtrl.create({
          title: "Sign Up Error",
          subTitle: error.message,
          buttons: ["Dismiss"]
        });

        alert.present();
      });
  }

  onTermsChecked($event) {
    if (!$event.checked) {
      this.form.patchValue({ eula: null });
      this.termsChecked = false;
    } else {
      this.termsChecked = true;
    }
  }

  onSubsChecked($event){
      if ( $event.checked){
          this.subscribeMe = true;
      } else {
        this.subscribeMe = false;
      }
  }


  onCurrencyChange(value: string) {

    //this.currency = value;
    this.currency = value;

    switch (value) {
      case 'usd':
        this.subscriptionLabel = 'USD2.00';
        break;
      case 'gnf':
        this.subscriptionLabel = 'GNF20,000';
        break;
      case 'gbp':
        this.subscriptionLabel = '‎£2.00';
        break;
      case 'eur':
        this.subscriptionLabel = '‎€2.00';
        break;
      default:
        this.subscriptionLabel = 'GNF20,000';
        break;
    }

  }

  signIn() {
    this.navCtrl.push("SignInPage");
  }

  pay() {
    this.navCtrl.push("SubscriptionsPage", {
      registerData: this.registerData
    });
  }

  sendNotification(message: string): void {
    let notification = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    notification.present();
  }

  signUp(token): void {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Getting ready... Please wait"
    });

    loading.present();

    this.authService
      .registerUser(
        this.registerData.email,
        this.registerData.password,
        this.registerData.password2
      )
      .then((x) => {
        loading.dismiss();

        this.firestoreService.updatePaymentTokenWeb(token.id, this.currency);
        this.events.publish('hasSubscribed')

        let alert = this.alertCtrl.create({
          title: "Thank You",
          subTitle: "Your payment was successful. Please verify your email address to access your account!",
          buttons: ["Dismiss"]
        });

        //alert.present();
        alert.onDidDismiss(() => {
          // this.navCtrl.pop();
        });

        this.sendNotification('Registration was successful!');


        this.navCtrl.setRoot("SignInPage");
      })
      .catch(error => {
        loading.dismiss();

        let alert = this.alertCtrl.create({
          title: "Sign Up Error",
          subTitle: error.message,
          buttons: ["Dismiss"]
        });

        alert.present();
      });
  }

  //Subscriptions
  ionViewDidLoad() {
    this.stripe.setPublishableKey('pk_live_2qIyEt45hg5KOews7PS6N4p6');


    setTimeout(() => {
      this.handler = StripeCheckout.configure({
        key: 'pk_live_2qIyEt45hg5KOews7PS6N4p6',
        image: 'http://ingeniousmac.com/wp-content/uploads/2019/02/IGM.png', // Picture you want to show in pop up
        locale: 'auto',
        token: token => {

//console.log(JSON.stringify(token));
          // Handle Stripe response
          let alert = this.alertCtrl.create({
            title: 'Response from Stripe',
            message: JSON.stringify(token),
            buttons: ['ok']
          });
          //alert.present();

          this.signUp(token);
        }
      })
    }, 1000)

  }

  payButtonClickHandler() {
    this.handlerOpen();  // To open your stripe pop-up
  }

  handlerOpen() {
    let amount = 23600;

    switch (this.currency) {
      case 'usd':
        amount = 236
        break;
      case 'gnf':
        amount = 23600
        break;
      case 'gbp':
        amount = 236
        break;
      case 'eur':
        amount = 236;
        break;
      default:
        amount = 236;
        this.currency = 'usd'
        break;
    }

    this.handler.open({
      name: 'Qiinii', // Pass your application name
      amount: amount, // Pass your billing amount
      email: this.registerData.email,
      currency: this.currency
    });
  }


  EULA() {

    const browser = this.iab.create(
      'https://ingeniousmac.com/user-agreement/'
    );
    browser.on('loadstop').subscribe(event => {
      browser.insertCSS({ code: 'body{color: red;}' });
    });

  }

  alertUser(message) {
    let alert = this.alertCtrl.create({
      title: "Error",
      subTitle: message,
      buttons: ["Dismiss"]
    });

    alert.present()
  }

  onCardNumberChange(e) {

    let cN = this.formatCardNumber(e);

    if (cN == '' || (cN == null)) {
      //
    } else {
      //this.cardNumber ="";
      //this.cardNumber = cN;
      //console.log(this.cardNumber)

    }

  }

  formatCardNumber(value) {
    var value = value.replace(/\D/g, '');
    var formattedValue;
    var maxLength;
    // american express, 15 digits
    if ((/^3[47]\d{0,13}$/).test(value)) {
      formattedValue = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
      maxLength = 17;
    } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
      formattedValue = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
      maxLength = 16;
    } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
      formattedValue = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ');
      maxLength = 19;
    }

    this.cardNumber = formattedValue;
    this.maxLength = maxLength;

    //$('#cc').attr('maxlength', maxLength);

    return formattedValue;
  }

  getToken() {
    let mainLoader = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Processing Payment. Please wait..."
    });

    mainLoader.present();

    let exp = this.cardExpiry;

    let res = exp.split("/");
    this.cardExpiryM = res[0];
    this.cardExpiryY = 20 + res[1];



    let card = {
      number: this.cardNumber,
      expMonth: this.cardExpiryM,
      expYear: this.cardExpiryY,
      cvc: this.cardCvv,
      currency: 'USD'
    };


    this.stripe.validateCardNumber(this.cardNumber).then(function () {

      //validate cvv
      this.stripe.validateCVC(this.cardCvv).then(() => {

        //validate expiry
        this.stripe.validateExpiryDate(this.cardExpiryM, this.cardExpiryY).then(() => {


        }).catch(function (error) {
          mainLoader.dismiss();
          let alert = this.alertCtrl.create({
            title: "Error",
            subTitle: "Please follow example format for card expiry.",
            buttons: ["Dismiss"]
          });

          alert.present()
          return;
        });

      }).catch(function (error) {
        mainLoader.dismiss();
        let alert = this.alertCtrl.create({
          title: "Error",
          subTitle: error,
          buttons: ["Dismiss"]
        });

        alert.present()
        return;
      });
    })
      .catch(function (error) {
        mainLoader.dismiss();
        let alert = this.alertCtrl.create({
          title: "Error",
          subTitle: error,
          buttons: ["Dismiss"]
        });

        alert.present()
        return;
      });

    //Finally create token
    this.stripe.createCardToken(card)
      .then((token) => {
        mainLoader.dismiss();

        //Register user
        this.signUp(token)




      })
      .catch((error) => {
        mainLoader.dismiss();
        let alert = this.alertCtrl.create({
          title: "Error",
          subTitle: error,
          buttons: ["Dismiss"]
        });

        alert.present()
      });


  }
}



// WEBPACK FOOTER //
// ./src/pages/sign-up/sign-up.ts